import { InjectionToken } from "@angular/core";
import { SegmentConfig } from "../models";

/** Segment Configuration Injection Token */
export const SEGMENT_CONFIG: InjectionToken<SegmentConfig> = new InjectionToken<SegmentConfig>('segment-analytics.config');